module.exports = __webpack_public_path__ + "img/canvas-frame-lg.e284ffa.svg";